import cn from 'classnames';
import { Tooltip } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import classes from './index.module.scss';

const CertificateStatus = ({ status }) => {
  let icon;

  if (status === 'Approved') {
    icon = (
      <CheckCircleOutlineOutlinedIcon
        className={cn(classes.icon, classes.green)}
      />
    )
  }

  if (status === 'Warning') {
    icon = (
      <InfoOutlinedIcon
        className={cn(classes.icon, classes.yellow)}
      />
    )
  }

  if (status === 'Blocked') {
    icon = (
      <CancelOutlinedIcon
        className={cn(classes.icon, classes.red)}
      />
    )
  }

  return icon ? (
    <Tooltip title={status}>
      {
        icon
      }
    </Tooltip>
  ) : null;
}

export default CertificateStatus;